<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="mb15">
        <span class='mr15'>
       <!-- v-has:systemAdminCreate="()=>$router.push('/system/admin_create')"-->
          <a-button type="primary" v-has:systemAdminCreate="()=>{$router.push({path:'/system/admin_create'})}">
            添加账号
          </a-button>
        </span>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" name='name'>
          <a-input v-model:value="search.keyword" :style="{width:'250px'}" placeholder="请输入管理员名称"></a-input>
        </a-form-item>
        <!-- <a-form-item label="用户状态" name='status'>
          <a-select v-model:value="search.status" :style="{width:'180px'}" placeholder="全部">
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option :value="1">
              正常
            </a-select-option>
            <a-select-option :value="0">
              禁用
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button  @click='pageSearchReset'>重置</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:status="{ record }">
          <span>{{record.status==1?'正常':'禁用'}}</span>
        </template>
        <template v-slot:action="{ record }">
          <a class="m-r-15" v-has:systemAdminDetail="()=>$router.push({path:'/system/admin_create',query:{id:record.id,type:'detail'}})" href="javascript:;">详情</a>
          <a class="m-r-15" v-has:systemAdminEdit="()=>$router.push({path:'/system/admin_create',query:{id:record.id,type:'edit'}})" href="javascript:;">修改</a>
          <a class="m-r-15" v-has:systemAdminStatus="()=>systemAdminStatus(0,record)" href="javascript:;" v-if='record.status==1'>禁用</a>
          <a class="m-r-15" v-has:systemAdminStatus="()=>systemAdminStatus(1,record)" href="javascript:;" v-if='record.status!=1'>启用</a>
          <a class="m-r-15" v-has:systemAdminDel="()=>systemAdminDel(record)" href="javascript:;">删除</a>
        </template>
      <template v-slot:pdaLogin="{ record }">
        <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="record.is_pda_login"  v-has:setPadAuth="()=>switchChange(record)" />
      </template>
            
      </a-table>
            <a-pagination size="small" :style="{marginTop:'20px',textAlign:'right'}" :current="search.page" :page-size="search.limit" :total="total" show-size-changer show-quick-jumper @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
</template>
<script>  
// import { DownOutlined } from '@ant-design/icons-vue';
import { ref, onMounted, inject } from "vue";
import { message } from "ant-design-vue";
import { getAdmin, statusAdmin,delAdmin,set_pda_login } from "@/api/system";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  status: "",
  page: 1,
  limit: 10,
};
export default {
  components: {},
  setup(props) {
    // // 初始化 分页信息和筛选项信息
    let total = ref(1);
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref();
    let listLoading = ref(false);
    let columns = [
      {
        title: "用户ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "用户账号",
        dataIndex: "account",
        key: "account",
      },
      {
        title: "用户名称",
        dataIndex: "username",
        key: "username",
      },
      {
        title: "联系电话",
        dataIndex: "phone",
        key: "phone",
      },
      
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        slots: { customRender: "status" },
      },
     {
        title: "可登录PDA",
        key: "pdaLogin",
        width:240,
        slots: { customRender: "pdaLogin" }
      },
      {
        title: "操作",
        key: "action",
        width:240,
        slots: { customRender: "action" },
      },
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 页面筛选项重置
    const pageSearchReset = () => {
      search.value = {
        ...defSearch,
        page: search.value.page,
        limit: search.value.limit,
      };
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pagelimit) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pagelimitChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const initData = async (values) => {
      listLoading.value = true;
      data.value=[]
      try {
        let res = await getAdmin(values)
          .then((res) => res.data)
          .catch((error) => error);
        listLoading.value = false;
        if (iscode(res)) {
          data.value = res.data.data;
          total.value = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        listLoading.value = false;
      }
    };
    const action = (e) => {
      console.log(e);
    };
    onMounted(() => {
      initData(search.value);
    });
    const $Modal = inject("$Modal");
    // 修改状态
    const systemAdminStatus = (status, data) => {
      $Modal.confirm({
        centered:true,
        content: `确定${status ? "启用" : "禁用"}该管理员？`,
        onOk: async () => {
          let result = await statusAdmin(status, data.id)
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            initData(search.value);
          }
        },
      });
    };
    // 删除管理员
    const systemAdminDel=async(data)=>{
       $Modal.confirm({
         centered:true,
        content: `确定删除该管理员？`,
        onOk: async () => {
          let result = await delAdmin( data.id)
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            initData(search.value);
          }
        },
      });
    }
    // 切换PDA 权限
    const switchChange=async (e)=>{
      console.log(e.is_pda_login)
       let result=await  set_pda_login({id:e.id,is_pda_login:e.is_pda_login}).then(res=>res.data).catch(error=>error)
       iscode(result,true)
         initData(search.value);
    }
    return {
      total,
      search,
      data,
      listLoading,
      columns,
      pageSearchChange,
      pageSearchReset,
      pageCurrentChange,
      pagelimitChange,
      action,
      systemAdminStatus,
      systemAdminDel,
      switchChange
    };
  },
};
</script>